import React from "react";
import classes from "./Payments.module.css";
import icon from "components/common/assets/10810331.png";

const PaymentFailed = () => {
  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <p className={classes.paragraph}>Your payment failed</p>
        <div>
          <img
            className={classes.icon}
            src={icon}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
